import React from "react";
import { Navbar, Logo, LangSelect } from "../../components";
import { languages } from "../../assets";
import { fade, expand, retract, hideOthers } from "../../utilities/functions";

import "./header.css";

// composited function for menu click
const iconClick = (container, menuClass, otherClass) => {
  let mql = window.matchMedia(`(max-width: 1024px)`);
  if (mql.matches) {
    hideOthers(otherClass);
    hideOthers(".sub-menu");
    const subHeader = document.querySelector(".sub-title-expanded");
    if (subHeader) {
      subHeader.classList.remove("sub-title-expanded");
    }
  }
  if (document.querySelector(`.${container.className} > .display-none`)) {
    expand(container, menuClass, 300);
  } else {
    retract(container, menuClass, 300);
  }
};

const linkClick = (container, menuClass) => {
  let mql = window.matchMedia(`(max-width: 1024px)`);
  if (mql.matches) {
    fade(container, menuClass, 15);
    hideOthers(".sub-menu");
    const subHeader = document.querySelector(".sub-title-expanded");
    if (subHeader) {
      subHeader.classList.remove("sub-title-expanded");
    }
  } else {
    hideOthers(".sub-menu");
  }
};

const logoClick = () => {
  let mql = window.matchMedia(`(max-width: 1024px)`);
  if (mql.matches) {
    hideOthers(".nav-menu");
    hideOthers(".sub-menu");
    const subHeader = document.querySelector(".sub-title-expanded");
    if (subHeader) {
      subHeader.classList.remove("sub-title-expanded");
    }
  } else {
    hideOthers(".sub-menu");
  }
};

const Header = ({ linkList, languageSelect }) => {
  return (
    <header className="header">
      <Navbar
        linkList={linkList}
        iconClickImp={(container, menuClass) =>
          iconClick(container, menuClass, ".lang-container .lang-menu")
        }
        linkClickImp={(container, menuClass) =>
          linkClick(container, menuClass, 15)
        }
        subClick={(container, menuClass) => iconClick(container, menuClass)}
      />
      <Logo logoClickImport={() => logoClick()} />
      <LangSelect
        languages={languages}
        menuClickImp={(container, menuClass) => iconClick(container, menuClass)}
        languageSelect={languageSelect}
      />
    </header>
  );
};

export default Header;
